import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToEventDetailsTranslation } from './i18n';
import type { GoToEventDetailsProps } from './types';
import { buildTestid } from '../../shared/lib/utils';

interface GoToEventDetailsButtonProps extends GoToEventDetailsProps, Omit<ButtonProps, 'children' | 'title'> {
  title?: React.ReactNode;
}

const displayName = 'GoToEventDetailsButton';
const testid = buildTestid(displayName);

function GoToEventDetailsButton({
  eventId,
  title = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToEventDetailsButtonProps): React.JSX.Element {
  const { t } = useGoToEventDetailsTranslation();

  return (
    <Button
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      size="small"
      to={generatePath(routes.events.eventDetails, { eventId })}
      {...testid(dataTestId)}
      {...props}
    >
      {title ?? t('title')}
    </Button>
  );
}

GoToEventDetailsButton.displayName = displayName;

export { GoToEventDetailsButton };
